import { loader } from 'graphql.macro'

export default async function unlinkClientFromQbo ({ dataLoaders, variables }) {
  const schema = loader('./unlinkClientFromQbo.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, {
    id: variables.id
  })
  return response.unlinkClientFromQbo
}
